import { jsxs as u, jsx as f } from "react/jsx-runtime";
import i from "classnames";
import v from "react";
import b from "styled-components";
import N from "../Icons/ChevronLeft.js";
import n from "../Icons/ExternalLink.js";
import l from "../../utils/colors.js";
const _ = b.a`
  letter-spacing: -0.3px;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${l.brown};
  text-decoration: underline;

  > svg {
    height: 1em;
  }

  > svg.chevronBack {
    position: relative;
    top: 0.16em;
    margin-right: 0.4em;

    > g > path {
      fill: ${l.brown};
    }
  }

  > svg.externalLink {
    ${(t) => t.$extraLinkOrder === "before" && "margin-right: 0.7em;"}
    ${(t) => t.$extraLinkOrder === "after" && "margin-left: 0.2em;"}
    height: 0.8em;
  }

  &:hover,
  &:active,
  &:focus {
    cursor: pointer;
    color: ${l.teal};

    > svg.chevronBack > g > path {
      fill: ${l.teal};
    }

    > svg > g > g {
      fill: ${l.teal};
    }
  }
`, x = v.forwardRef(function({
  value: c,
  href: g = "#",
  showExtraLink: r = !1,
  showBackChevron: s = !1,
  children: h,
  extraLinkProps: e,
  extraLinkOrder: m = "after",
  chevronProps: a,
  target: o = "_blank",
  ...$
}, d) {
  return /* @__PURE__ */ u(
    _,
    {
      href: g,
      ...$,
      target: o,
      ref: d,
      $extraLinkOrder: m,
      ...o === "_blank" ? { rel: "noopener noreferrer" } : {},
      children: [
        s && /* @__PURE__ */ f(N, { ...a, className: i("chevronBack", a == null ? void 0 : a.className) }),
        r && m == "before" && /* @__PURE__ */ f(
          n,
          {
            ...e,
            className: i("externalLink", e == null ? void 0 : e.className)
          }
        ),
        h || c,
        r && m == "after" && /* @__PURE__ */ f(
          n,
          {
            ...e,
            className: i("externalLink", e == null ? void 0 : e.className)
          }
        )
      ]
    }
  );
});
export {
  x as Link,
  x as default
};
